var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 17H0.21875V7.65625H3.125V17ZM1.65625 6.40625C0.75 6.40625 0 5.625 0 4.6875C0 3.78125 0.75 3.03125 1.65625 3.03125C2.59375 3.03125 3.34375 3.78125 3.34375 4.6875C3.34375 5.625 2.59375 6.40625 1.65625 6.40625ZM13.9688 17H11.0938V12.4688C11.0938 11.375 11.0625 10 9.5625 10C8.0625 10 7.84375 11.1562 7.84375 12.375V17H4.9375V7.65625H7.71875V8.9375H7.75C8.15625 8.21875 9.09375 7.4375 10.5 7.4375C13.4375 7.4375 14 9.375 14 11.875V17H13.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.db9ee4a701ad80baf58071a0db67ce6f.svg";
export { ForwardRef as ReactComponent };